export const checkInputValue = (
  value: string | number | boolean | null | undefined,
  expected: string = "string",
): string | number | null => {
  if (value === null || value === undefined) {
    return "";
  }

  if (expected === "index" && value === 0) {
    return "";
  }

  if (typeof value === "boolean") {
    return value ? 1 : 0;
  }

  if (typeof value === "string" && expected === "number") {
    const num = parseFloat(value);
    return Number.isNaN(num) ? value : num;
  }

  return value;
};
